import React, { Component } from 'react';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

import tableRequest from '../../models/tableRequest.js';
import DispatchReportService from '../../services/DispatchReportService';

import MessageComponent from '../../template/Message';
import Loaders from '../../template/Loaders';

export default class CompleteObdManually extends Component {

    constructor(props) {
        super(props);

        this.DispatchReportService = new DispatchReportService();
        this.tblResponse = new tableRequest();

        this.state = {
            FromDate: new Date(),
            ToDate: new Date(),
            sales: [],
            loading: false,
            updateLoader: false,
            first: 0,
            rows: 10,
            totalRecords: 0,
            globalFilter: ''
        };
    }

    componentDidMount() {
        let date = new Date();
        date.setDate(date.getDate() - 7);

        this.setState({
            FromDate: date,
            ToDate: new Date()
        });

        this.tblResponse.FromDate = date.toLocaleDateString();
        this.tblResponse.ToDate = new Date().toLocaleDateString();
        this.tblResponse.PageSize = this.state.rows;
        this.tblResponse.First = this.state.rows;

        this.GetDispatch();
    }

    // ✅ PAGINATION FIX
    onPage = (event) => {

        const pageNo = Math.floor(event.first / event.rows) + 1;

        this.setState({
            first: event.first,
            rows: event.rows,
            loading: true,
            updateLoader: true
        });

        this.tblResponse.PageSize = event.rows;
        this.tblResponse.First = pageNo * event.rows;

        this.GetDispatch();
    };

    // ✅ SEARCH
    searchFilter = (e) => {
        this.tblResponse.SearchValue = e.target.value;

        this.setState({
            loading: true,
            updateLoader: true,
            first: 0
        });

        this.tblResponse.First = this.state.rows;

        this.GetDispatch();
    };

    // ✅ FILTER
    FilterData = () => {

        this.setState({
            loading: true,
            updateLoader: true,
            first: 0
        });

        this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString();
        this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString();
        this.tblResponse.First = this.state.rows;

        this.GetDispatch();
    };

    // ✅ API CALL
    GetDispatch = () => {

        this.DispatchReportService.GetOBDJsonReportForCompletion(this.tblResponse)
            .then(res => {

                const data = res.data?.ResponseData || [];

                this.setState({
                    sales: data,
                    totalRecords: data.length > 0 ? data[0].TotalRows : 0,
                    loading: false,
                    updateLoader: false
                });
            })
            .catch(() => {
                this.setState({
                    sales: [],
                    totalRecords: 0,
                    loading: false,
                    updateLoader: false
                });
            });
    };

    // ✅ DOWNLOAD TXT
 markCompleted = (rowData) => {

    const completeOBD = async () => {

        try {

            this.setState({
                updateLoader: true
            });

            const response =
                await this.DispatchReportService.MarkOBDCompleted(
                    rowData.DeliveryNo
                );

            if (response.data.ResponseCode === "200") {

                this.refs.Messchild.showSuccess(
                    `Delivery ${rowData.DeliveryNo} marked as completed`
                );

                this.GetDispatch();
            }
            else {

                this.refs.Messchild.showError(
                    response.data.ResponseMessage
                );
            }
        }
        catch (err) {

            this.refs.Messchild.showError(
                err?.response?.data?.ResponseMessage ||
                err?.message
            );
        }
        finally {

            this.setState({
                updateLoader: false
            });
        }
    };

    return (
        <Button
            label="Mark Completed"
            icon="pi pi-check"
            className="p-button-success"
            onClick={completeOBD}
        />
    );
};

    // ✅ HEADER UI FIXED
    renderHeader = () => (
        <div className="row align-items-center mb-3">

            <div className="col-md-8">
                <div className="d-flex gap-3 flex-wrap">

                    <div style={{ minWidth: "180px" }}>
                        <label>From Date</label>
                        <Calendar
                            value={this.state.FromDate}
                            onChange={(e) => this.setState({ FromDate: e.value })}
                            dateFormat="dd-mm-yy"
                            showIcon
                            className="w-100"
                        />
                    </div>

                    <div style={{ minWidth: "180px" }}>
                        <label>To Date</label>
                        <Calendar
                            value={this.state.ToDate}
                            onChange={(e) => this.setState({ ToDate: e.value })}
                            dateFormat="dd-mm-yy"
                            showIcon
                            className="w-100"
                        />
                    </div>

                    <div style={{ marginTop: "24px" , marginLeft: "10px"}}>
                        <Button label="Submit" onClick={this.FilterData} />
                    </div>

                </div>
            </div>

            <div className="col-md-4 text-end">
                <InputText
                    placeholder="Search"
                    onInput={this.searchFilter}
                    style={{ height: "38px", width: "200px" }}
                />
            </div>

        </div>
    );

    render() {

        return (
            <>
                <MessageComponent ref="Messchild" />
                {this.state.updateLoader && <Loaders loader={true} />}

                <h3>Complete OBD</h3>

                <DataTable
                    value={this.state.sales}
                    paginator
                    lazy
                    first={this.state.first}
                    rows={this.state.rows}
                    totalRecords={this.state.totalRecords}
                    onPage={this.onPage}
                    loading={this.state.loading}
                    rowsPerPageOptions={[10, 20, 50]}
                    header={this.renderHeader()}
                >
                    <Column field="DeliveryNo" header="Delivery No" />
                    <Column field="DeliveryDate" header="Date" />
                    <Column field="Plant" header="Plant" />
                    <Column field="ShipToPartyName" header="Party" />
                    <Column field="Status" header="Status" />

                    {/* DOWNLOAD */}
                  <Column body={this.markCompleted} header="Action" />
                </DataTable>
            </>
        );
    }
}